import { useEffect } from 'react';
import { matchPath, useHistory, useLocation } from 'react-router';
import { useDatasetSessionStorageContext } from '../../../hooks/context/useDatasetSessionStorageContext';
import { useDatasetContext } from '../../../hooks/context/useDatasetContext';
import useRoutes from '../../../hooks/useRoutes';
import { isFromPageReload } from '../../../utils/isFromPageReload';
import { GlobalLocationStateType } from '../../../types/types';

export const useDatasetUrlDetailReloadGuard = () => {
  const { pathname } = useLocation<GlobalLocationStateType>();
  const routes = useRoutes();
  const history = useHistory();
  const { setDatasetSessionStorageState, getDatasetSessionStorageState } =
    useDatasetSessionStorageContext();
  const { datasetId } = useDatasetContext();

  useEffect(() => {
    const handler = () => {
      if (!datasetId) return;

      const isDetailUrl =
        !!matchPath(pathname, {
          path: routes.relative.datasetDetail(),
          exact: true,
          strict: false,
        }) ||
        !!matchPath(pathname, {
          path: routes.relative.datasetDetailSubset(),
          exact: true,
          strict: false,
        });

      if (isDetailUrl) {
        setDatasetSessionStorageState({ reloadFromItem: true });
      }
    };

    window.addEventListener('beforeunload', handler);

    return () => {
      window.removeEventListener('beforeunload', handler);
    };
  }, [datasetId, pathname]);

  useEffect(() => {
    if (!datasetId) return;
    if (!isFromPageReload()) return;

    const state = getDatasetSessionStorageState();
    setDatasetSessionStorageState({ reloadFromItem: undefined });

    // Reload of a detail URL always returns to the list; for filterFirst
    // datasets the list's redirect guard then applies the standard
    // filterFirst modal flow.
    if (state.reloadFromItem === true) {
      history.push(routes.datasetList(datasetId));
    }
  }, [datasetId]);
};
